import { render, staticRenderFns } from "./comp_PortugueseSongSection.vue?vue&type=template&id=017e2b50&"
import script from "./comp_PortugueseSongSection.vue?vue&type=script&lang=js&"
export * from "./comp_PortugueseSongSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports